var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.props.imageElement
    ? _c("div", { staticClass: "image-effects-properties-wrapper" }, [
        _c("label", [_vm._v("Effects")]),
        _vm._v(" "),
        _c("div", { staticClass: "divider mb-3" }),
        _vm._v(" "),
        _setup.hasEffects
          ? _c(
              "div",
              { staticClass: "draggable-list-wrapper mb-3" },
              [
                _c(_setup.ImageEffectsPropertiesList, {
                  attrs: {
                    items: _setup.model.imageEffects,
                    disabled: _setup.isDisabled,
                  },
                  on: {
                    remove: _setup.removeImageEffect,
                    update: _setup.updateImageEffect,
                    reorder: _setup.handleReorder,
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _setup.showMixed
          ? _c(
              "div",
              {
                staticClass:
                  "item-row px-3 py-2 d-flex align-items-center w-100 mixed-row",
                class: { pointer: !_setup.isDisabled },
                on: {
                  click: function ($event) {
                    !_setup.isDisabled && _setup.openAddEffectModal()
                  },
                },
              },
              [
                _vm._v("\n        Mixed Effects "),
                _c("span", [_vm._v("Replace")]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.imageElement.imageToImage
          ? _c(
              "div",
              { staticClass: "d-flex justify-content-center" },
              [
                _c(_setup.CButton, {
                  staticClass: "w-full",
                  attrs: {
                    size: "md",
                    text: "Add Image Effect",
                    variant: "light",
                    icon: ["fa-solid", "fa-sparkles"],
                    disabled: _setup.isDisabled,
                  },
                  on: { click: _setup.openAddEffectModal },
                }),
                _vm._v(" "),
                _c(_setup.ImageEffectsPropertiesCreate, {
                  on: { update: _setup.updateImageEffect },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "footer mt-4" },
          [
            _c("div", { staticClass: "divider mb-3" }),
            _vm._v(" "),
            _c("font-awesome-icon", {
              attrs: { icon: ["fa-solid", "fa-key"] },
            }),
            _vm._v("\n        Connect your API keys in "),
            _c(
              "a",
              { attrs: { href: "/account/integrations", target: "_blank" } },
              [_vm._v("Account Integrations")]
            ),
            _vm._v(".\n    "),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }